export const selectUsersData = state => state.auth
